var _style, _rect, _defs, _defs2, _defs3, _path, _defs4, _defs5, _path2, _path3, _defs6, _defs7, _defs8, _path4, _defs9, _defs10, _defs11, _path5, _path6, _defs12, _defs13, _defs14, _defs15, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurtleSvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2250 1500",
    style: {
      enableBackground: "new 0 0 2250 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#FFFFFF;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000116940352933574408410000014745239653977727639_);fill:url(#SVGID_00000031911014357548218130000010848551384316815027_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000041280239703908433450000004477124141978680500_);fill:url(#SVGID_00000137854684456778904080000001530389722014608570_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000143576328055586971530000007244971600736587678_);fill:url(#SVGID_00000028313064218431464050000008450645764443181209_);}\n\t.st4{opacity:0.13;fill-rule:evenodd;clip-rule:evenodd;fill:#001422;}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000021822728391839134450000003669662299980218521_);fill:url(#SVGID_00000092430258930176474740000006170976561967094915_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000013153004964836042250000017278811132556397474_);fill:url(#SVGID_00000057851454927398210780000001382305290460779655_);}\n\t.st7{opacity:0.19;fill-rule:evenodd;clip-rule:evenodd;fill:#070317;}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000027576539675782351160000005564573260057452686_);fill:url(#SVGID_00000011009341333769207110000006024612690935386511_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000178910166868987605760000016882301176021496470_);fill:url(#SVGID_00000172409739741255600730000000175815747862184375_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000127017428212478008380000004441855986552757377_);fill:url(#SVGID_00000092430289143355990910000008882349472476290461_);}\n\t.st11{opacity:0.28;fill-rule:evenodd;clip-rule:evenodd;fill:#FA9CFF;}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000178899581673376682030000011337403087421557141_);fill:url(#SVGID_00000170966292024725815920000006306774292575984018_);}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000183965173593862569570000008788685278968126631_);fill:url(#SVGID_00000081645592874592837820000005891174300050606740_);}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000132783087841800806180000003307357345964532151_);fill:url(#SVGID_00000041975774391497003780000012208728961142330023_);}\n\t.st15{opacity:0.19;fill-rule:evenodd;clip-rule:evenodd;}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000095330913194067800740000012845061730360299649_);fill:url(#SVGID_00000127046439088039869620000005630003370563563138_);}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000017499533645211823520000013266332363074868406_);fill:url(#SVGID_00000173854931236198577350000006963990243112890255_);}\n\t\n\t\t.st18{clip-path:url(#SVGID_00000119808552548542994190000014892779484668536983_);fill:url(#SVGID_00000059998453214428124890000003011283956837290678_);}\n\t\n\t\t.st19{clip-path:url(#SVGID_00000132077624517552210820000006237087054687117722_);fill:url(#SVGID_00000033360294304850129900000016091543999634487720_);}\n\t.st20{opacity:0.21;fill-rule:evenodd;clip-rule:evenodd;fill:#FEFEFE;}\n\t.st21{opacity:0.21;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st22{opacity:0.36;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st23{display:none;fill:#29ABE2;stroke:#000000;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 2250,
    height: 1500
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1542.95,747.61c0,0,270.94-152.88,462.85-81.27c0,0,154.68-22.91,206.23-100.25 c0,0-97.38-211.96-326.53-211.96c0,0-65.02,15.51-180.48,88.8l-104.54,66.23L1542.95,747.61z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057858119660090095620000016491891326037147314_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182495891074004254410000005457492774672819352_",
    gradientUnits: "userSpaceOnUse",
    x1: 1687.7755,
    y1: 582.3211,
    x2: 2225.1479,
    y2: 493.2174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1542.95,
    y: 354.12,
    style: {
      clipPath: "url(#SVGID_00000057858119660090095620000016491891326037147314_)",
      fill: "url(#SVGID_00000182495891074004254410000005457492774672819352_)"
    },
    width: 669.08,
    height: 393.48
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000021086631120373528650000017351444773366268299_",
    d: "M2212.03,566.08c0,0-97.38-211.96-326.53-211.96 c0,0-52.42,12.51-146.69,68.11C1822.56,489.45,1972.89,569.45,2212.03,566.08"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067940362907667337090000008863164719433575848_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021086631120373528650000017351444773366268299_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181061501812876041730000001861273763320858758_",
    gradientUnits: "userSpaceOnUse",
    x1: 1604.3131,
    y1: 557.1583,
    x2: 2213.1873,
    y2: 400.6765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1738.81,
    y: 354.12,
    style: {
      clipPath: "url(#SVGID_00000067940362907667337090000008863164719433575848_)",
      fill: "url(#SVGID_00000181061501812876041730000001861273763320858758_)"
    },
    width: 473.22,
    height: 215.32
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044152843252979542540000013029413425536756117_",
    d: "M1542.95,747.61c0,0,270.94-152.88,462.85-81.27 c0,0,38.85-5.75,84.1-21.23c0,0-328.04-160.65-519.67,42.01c-6.44,6.81-12.22,13.44-17.49,19.92L1542.95,747.61z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023987588653252620760000001558463849769151630_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044152843252979542540000013029413425536756117_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025406547029208862060000009361684324007687865_",
    gradientUnits: "userSpaceOnUse",
    x1: 1758.6967,
    y1: 637.9602,
    x2: 2138.7627,
    y2: 493.5791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1542.95,
    y: 484.46,
    style: {
      clipPath: "url(#SVGID_00000023987588653252620760000001558463849769151630_)",
      fill: "url(#SVGID_00000025406547029208862060000009361684324007687865_)"
    },
    width: 546.95,
    height: 263.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1542.95,747.61c0,0,92.49-52.18,207.67-81.29c-14.59-123.37-45.61-223.4-45.61-223.4l-104.54,66.23 L1542.95,747.61z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000155117162958827629450000011730631683584571040_",
    d: "M1705.01,442.92 c-612.08,379.54-592.9,513.61-1535.62,448.29C797.72,1344.58,1793.72,1224.32,1705.01,442.92"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041253752560069003240000000500797425913877154_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155117162958827629450000011730631683584571040_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108272905419897009820000006366257010612653753_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.9844,
    y1: 1139.9014,
    x2: 1719.5461,
    y2: 641.304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B1BA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#65C7F7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.39,
    y: 442.92,
    style: {
      clipPath: "url(#SVGID_00000041253752560069003240000000500797425913877154_)",
      fill: "url(#SVGID_00000108272905419897009820000006366257010612653753_)"
    },
    width: 1624.32,
    height: 901.66
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000164499939112257800780000012557574937616422529_",
    d: "M169.39,891.21 c609.45,439.76,1564.77,339.78,1540.66-379.71C1708.69,519.44,1543.21,1460.76,169.39,891.21"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021828093597040740440000008075807082457991359_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164499939112257800780000012557574937616422529_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027564894764043649480000009822983903219145144_",
    gradientUnits: "userSpaceOnUse",
    x1: 608.1544,
    y1: 1102.0995,
    x2: 1734.3269,
    y2: 722.0325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B1BA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#65C7F7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.39,
    y: 511.51,
    style: {
      clipPath: "url(#SVGID_00000021828093597040740440000008075807082457991359_)",
      fill: "url(#SVGID_00000027564894764043649480000009822983903219145144_)"
    },
    width: 1564.77,
    height: 949.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1597.03,511.37c-48.05,31.1-91.86,60.25-132.6,87.53c-25.39,252.26-211.25,514.24-215.63,520.39 c114.68-31.74,215.75-84.96,293.89-160.23c73.93-203.68,65.81-384.88,65.81-384.88L1597.03,511.37z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M707.73,902.89c-126.05,7.51-280.32,4.74-479.87-7.83c-7.12,7.11-14.18,14.44-21.19,21.98 c83.32,55.89,172.33,102.12,263.9,138.47C572.17,1012.27,649.53,957.48,707.73,902.89"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000009573820742110840960000012482388646174428317_",
    d: "M951.73,1336.59 c635.89-223.42,636.5-696.49,636.5-696.49C1235.37,768.33,1033.83,917.47,951.73,1336.59"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019680039009014011680000003676910927401406111_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009573820742110840960000012482388646174428317_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052102942930152748690000013347294730715012253_",
    gradientUnits: "userSpaceOnUse",
    x1: 1033.8748,
    y1: 1323.7003,
    x2: 1301.4607,
    y2: 943.6342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 951.73,
    y: 640.1,
    style: {
      clipPath: "url(#SVGID_00000019680039009014011680000003676910927401406111_)",
      fill: "url(#SVGID_00000052102942930152748690000013347294730715012253_)"
    },
    width: 636.5,
    height: 696.49
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000111189252288082889530000002655975654191471541_",
    d: "M1278.59,788.6 c-157.18,106.44-260.29,253.71-316.92,501.27C1116.95,1147.59,1216.42,955.31,1278.59,788.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159433238452613246250000006957242716660584604_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111189252288082889530000002655975654191471541_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101087640247419631960000015338380698769780619_",
    gradientUnits: "userSpaceOnUse",
    x1: 914.1837,
    y1: 1255.2051,
    x2: 1202.3956,
    y2: 952.967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 961.67,
    y: 788.6,
    style: {
      clipPath: "url(#SVGID_00000159433238452613246250000006957242716660584604_)",
      fill: "url(#SVGID_00000101087640247419631960000015338380698769780619_)"
    },
    width: 316.92,
    height: 501.27
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000089537607073463069210000008423755344598453436_",
    d: "M1075.74,1286.35 c511.85-236.96,512.48-646.25,512.48-646.25c-6.17,2.24-12.3,4.49-18.37,6.75C1330.15,851.58,1165.88,1115.52,1075.74,1286.35"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000051360699722947018860000000776351141380263816_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089537607073463069210000008423755344598453436_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176728195582251465510000006939326207844764569_",
    gradientUnits: "userSpaceOnUse",
    x1: 1114.5021,
    y1: 1214.8295,
    x2: 1386.2141,
    y2: 900.4909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1075.74,
    y: 640.1,
    style: {
      clipPath: "url(#SVGID_00000051360699722947018860000000776351141380263816_)",
      fill: "url(#SVGID_00000176728195582251465510000006939326207844764569_)"
    },
    width: 512.48,
    height: 646.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M951.73,1336.59c635.89-223.42,636.5-696.49,636.5-696.49c-17.63,6.41-34.85,12.86-51.72,19.4 c-2.49,7.54-4.85,15.15-6.92,22.91c-107.96,405.02-552.89,552.96-554.41,553.47C966.5,1267.63,958.68,1301.12,951.73,1336.59"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000079465426291500021230000015522591742136134026_",
    d: "M49.97,1140.14 C722,1088.92,845.03,632.12,845.03,632.12C471.02,664.66,237.75,756.55,49.97,1140.14"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005955886600383679580000003281468326866328706_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079465426291500021230000015522591742136134026_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166646327135828371290000011866580337504441745_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.5345,
    y1: 1148.926,
    x2: 489.4997,
    y2: 851.0883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.97,
    y: 632.12,
    style: {
      clipPath: "url(#SVGID_00000005955886600383679580000003281468326866328706_)",
      fill: "url(#SVGID_00000166646327135828371290000011866580337504441745_)"
    },
    width: 795.07,
    height: 508.02
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000077323926711510978670000010409884386976166074_",
    d: "M507.51,695.42 c-179.38,62.13-317.09,177.7-435.86,402.17C258.47,1000.35,404.32,840.36,507.51,695.42"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025430366109534826870000004622075032952284074_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077323926711510978670000010409884386976166074_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146460629037193870590000000977204417010841223_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.5673,
    y1: 1051.8339,
    x2: 391.2578,
    y2: 834.5745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.65,
    y: 695.42,
    style: {
      clipPath: "url(#SVGID_00000025430366109534826870000004622075032952284074_)",
      fill: "url(#SVGID_00000146460629037193870590000000977204417010841223_)"
    },
    width: 435.86,
    height: 402.17
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000138548303642083473190000007870445674577200003_",
    d: "M182.75,1123.71 c555.74-96.42,662.28-491.59,662.28-491.59c-6.54,0.57-13.04,1.16-19.49,1.77C541.01,769.6,314.03,982.03,182.75,1123.71"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090286393096664487390000001290058731932988289_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138548303642083473190000007870445674577200003_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116216318976973095310000004220052620696375997_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.6706,
    y1: 1064.6277,
    x2: 582.4353,
    y2: 831.4175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#901755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB7228"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 182.75,
    y: 632.12,
    style: {
      clipPath: "url(#SVGID_00000090286393096664487390000001290058731932988289_)",
      fill: "url(#SVGID_00000116216318976973095310000004220052620696375997_)"
    },
    width: 662.28,
    height: 491.59
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M49.97,1140.14c672.04-51.22,795.07-508.02,795.07-508.02c-18.68,1.63-36.99,3.41-54.97,5.35 c-4.36,6.64-8.61,13.38-12.61,20.35c-209.12,363.27-677.16,391.01-678.76,391.11C82.08,1077.36,65.86,1107.68,49.97,1140.14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1705.01,442.92c-612.08,379.54-592.9,513.61-1535.62,448.29c6.54,4.72,13.17,9.28,19.79,13.88 c323.12,82.02,1269.98,265.22,1520.17-325.19C1711.8,536.73,1710.48,491.1,1705.01,442.92"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000178203561487919759450000015865148841504865954_",
    d: "M37.97,855.39c0,0,1463.68,464.02,1667.04-412.47 C1095.47-209.07,536.05,453.4,37.97,855.39"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053506425990331403270000017758694517137071250_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178203561487919759450000015865148841504865954_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160159288648571417400000009384394184585436584_",
    gradientUnits: "userSpaceOnUse",
    x1: 1670.7506,
    y1: 353.5945,
    x2: 16.5555,
    y2: 770.7881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7BFBD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEFEFE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.97,
    y: -209.07,
    style: {
      clipPath: "url(#SVGID_00000053506425990331403270000017758694517137071250_)",
      fill: "url(#SVGID_00000160159288648571417400000009384394184585436584_)"
    },
    width: 1667.04,
    height: 1528.48
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000086685590411924089070000014908478522750184091_",
    d: "M37.97,855.39c0,0,1434.42,392.5,1608.53-418.97 C1036.94-215.57,536.05,453.4,37.97,855.39"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150102471312828375040000016247093962592525198_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086685590411924089070000014908478522750184091_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152255247182760542620000003568449011959600278_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.0446,
    y1: 713.7393,
    x2: 1415.0797,
    y2: 380.1502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E93CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FFBDE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.97,
    y: -215.57,
    style: {
      clipPath: "url(#SVGID_00000150102471312828375040000016247093962592525198_)",
      fill: "url(#SVGID_00000152255247182760542620000003568449011959600278_)"
    },
    width: 1608.53,
    height: 1463.46
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000126294419039966282380000015898316736513537666_",
    d: "M37.97,855.39c0,0,1256.99,343.9,1560.38-277.88 C1232.3,343.67,836.5,358.6,483.73,469.46C333.06,594.05,185.39,736.41,37.97,855.39"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031209327473925107780000003443738432356205236_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126294419039966282380000015898316736513537666_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089547866967972325500000018233096933963559871_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.0837,
    y1: 933.9286,
    x2: 1400.3502,
    y2: 536.2612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E93CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FFBDE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.97,
    y: 343.67,
    style: {
      clipPath: "url(#SVGID_00000031209327473925107780000003443738432356205236_)",
      fill: "url(#SVGID_00000089547866967972325500000018233096933963559871_)"
    },
    width: 1560.38,
    height: 855.62
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000082354698311370182140000010558119364729696701_",
    d: "M37.97,855.39c0,0,1434.42,392.5,1608.53-418.97 c-31.94-34.16-63.56-64.48-94.91-91.62C1253.72,916.33,37.97,855.39,37.97,855.39"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066508662341625920600000012535482732008900028_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082354698311370182140000010558119364729696701_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132047358372149450240000006102619480767497140_",
    gradientUnits: "userSpaceOnUse",
    x1: 517.1029,
    y1: 998.2527,
    x2: 1593.2241,
    y2: 329.9731
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E93CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FFBDE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.97,
    y: 344.8,
    style: {
      clipPath: "url(#SVGID_00000066508662341625920600000012535482732008900028_)",
      fill: "url(#SVGID_00000132047358372149450240000006102619480767497140_)"
    },
    width: 1608.53,
    height: 903.09
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M37.97,855.39c0,0,73.35,20.03,188.67,41.69c269.52-256.09,690.96-580.66,1162.64-664.92 C892.56-28.06,464.23,511.37,37.97,855.39"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1810.46,383.77c76.8,52.92,226.7,141.16,383.71,150.67c-37.45-59.09-135.39-180.31-308.68-180.31 C1885.5,354.12,1859.24,360.39,1810.46,383.77"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M735.92,358.15c-67.1,159.92,49.26,88.55,247.07,47.13c197.81-41.42,223.9-71.99,352.52,0.57 c128.62,72.57,335.04,126.2,247.27,9.18c-87.77-117.03-191.96-173.72-263.32-201.56C1170.66,155.45,803.02,198.23,735.92,358.15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M950.57,283.8c-40.2,88.76,26.27,50.51,138.03,30.36c111.75-20.14,126.88-36.9,197.97,5.88 c71.1,42.78,186.18,76.15,138.73,9.05c-47.45-67.11-105.07-100.6-144.71-117.35C1197.94,176.8,990.78,195.04,950.57,283.8"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2181.32,1361.86v-29.74h-82.5v-31.92h71.65v-29.75h-71.65v-30.83h81.42v-29.74h-114.42v151.98H2181.32z  M2040.63,1361.86v-30.18h-75.77v-121.8h-33.44v151.98H2040.63z M1905.81,1240.71v-30.83h-125.92v30.83h46.24v121.15h33.43v-121.15 H1905.81z M1726.69,1262.21c0,6.51-2.21,11.72-6.62,15.63c-4.41,3.91-10.75,5.86-19,5.86h-33.87v-43.64h33.22 c8.25,0,14.69,1.81,19.32,5.43c4.63,3.62,6.95,9.05,6.95,16.29V1262.21z M1765.12,1361.86l-37.13-54.28 c9.7-3.62,17.55-9.3,23.56-17.04c6.01-7.74,9.01-17.77,9.01-30.07v-0.44c0-15.77-5.03-28.08-15.09-36.91 c-10.06-8.83-24.14-13.24-42.23-13.24h-69.47v151.98h33.44v-48.63h26.27l32.57,48.63H1765.12z M1599.68,1295.64v-85.76h-33.44v87.06 c0,12.16-2.89,21.28-8.69,27.36c-5.79,6.08-13.82,9.12-24.1,9.12c-10.27,0-18.31-3.15-24.1-9.44c-5.79-6.3-8.69-15.67-8.69-28.12 v-85.98h-33.43v86.84c0,22.44,5.86,39.3,17.59,50.59c11.72,11.29,27.79,16.93,48.2,16.93c10.13,0,19.32-1.41,27.57-4.23 c8.25-2.82,15.27-7.09,21.06-12.81s10.24-12.84,13.35-21.39C1598.12,1317.28,1599.68,1307.22,1599.68,1295.64z M2044.44,1426.15 v-8.12h-22.51v-8.71h19.55v-8.12h-19.55v-8.41h22.21v-8.12h-31.22v41.47H2044.44z M1949.64,1426.15v-41.47h-9v25.53l-19.43-25.53 h-8.41v41.47h9.01v-26.36l20.08,26.36H1949.64z M1849.1,1426.15v-41.47h-9.12v41.47H1849.1z M1779.35,1426.15v-8.23h-20.67v-33.23 h-9.12v41.47H1779.35z M1687.45,1420.28v-18.01h-18.01v7.88h9.18v5.96c-2.33,1.67-5.2,2.51-8.59,2.51c-1.86,0-3.54-0.33-5.06-0.98 c-1.52-0.65-2.84-1.58-3.97-2.76c-1.13-1.18-2-2.58-2.61-4.19c-0.61-1.6-0.92-3.36-0.92-5.25v-0.12c0-1.78,0.3-3.46,0.92-5.02 c0.61-1.57,1.46-2.93,2.55-4.1c1.09-1.16,2.35-2.1,3.79-2.79c1.44-0.69,2.99-1.04,4.65-1.04c1.18,0,2.27,0.1,3.26,0.3 c0.99,0.2,1.91,0.47,2.76,0.83c0.85,0.36,1.67,0.79,2.46,1.3c0.79,0.51,1.58,1.11,2.37,1.78l5.75-6.93 c-1.07-0.91-2.17-1.72-3.32-2.43c-1.15-0.71-2.37-1.3-3.67-1.78c-1.3-0.47-2.72-0.84-4.23-1.1c-1.52-0.26-3.21-0.38-5.07-0.38 c-3.16,0-6.06,0.56-8.71,1.69c-2.65,1.13-4.94,2.67-6.87,4.62c-1.94,1.96-3.45,4.23-4.53,6.81c-1.09,2.59-1.63,5.36-1.63,8.32v0.12 c0,3.08,0.53,5.92,1.6,8.53c1.07,2.61,2.56,4.86,4.47,6.75c1.92,1.89,4.21,3.38,6.87,4.44c2.66,1.07,5.62,1.6,8.86,1.6 c3.79,0,7.16-0.64,10.1-1.93C1682.78,1423.65,1685.32,1422.1,1687.45,1420.28z M1573.46,1408.79h-11.02l5.51-13.45L1573.46,1408.79z  M1590.04,1426.15l-17.77-41.76h-8.41l-17.77,41.76h9.3l3.79-9.3h17.54l3.79,9.3H1590.04z M1489.32,1393.1v-8.41h-34.36v8.41h12.62 v33.05h9.12v-33.05H1489.32z M1444.01,1240.71v-30.83h-125.92v30.83h46.24v121.15h33.43v-121.15H1444.01z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtleSvgLogo2);
export default __webpack_public_path__ + "static/media/turtle-svg-logo-2.219f7789deb85b1a04ecc8b8460a7196.svg";
export { ForwardRef as ReactComponent };